<template>
  <div class="box">
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      :modal-append-to-body="false"
      :show-close="false"
      width="100%"
      style="margin-top: 0; height: 100vh"
      v-loading="loading"
    >
      <div class="tree">
        <el-input
          class="input"
          placeholder="搜索关键字"
          v-model="filterText"
          prefix-icon="el-icon-search"
        >
        </el-input>
        <div class="treeList">
          <el-tree
            :data="treeList"
            show-checkbox
            node-key="username"
            :props="{ children: 'child' }"
            :filter-node-method="filterNode"
            ref="tree"
            @check="checkTree"
            :default-expanded-keys="nodeList"
            :default-checked-keys="user"
          >
            <div class="custom-tree-node" slot-scope="{ data }">
              <span>
                <template v-if="data.type === 'user'">
                  <i class="el-icon-user-solid"></i>
                  {{ data.nickname }}
                </template>
                <template>
                  <!-- <img
                    style="width: 18px; height: 18px; margin-right: 6px"
                    v-if="data.type != 'user'"
                    src="@/assets/depament1.svg"
                    alt=""
                  /> -->
                  {{ data.departmentName }}
                </template>
              </span>
              <!-- <div>
                <img
                  v-if="data.child.length > 0"
                  src="@/assets/depament1.svg"
                  alt=""
                />
                <span v-if="data.child.length > 0">{{ data.nickname }}</span>
                <span v-else>{{ data.nickname }}</span>
              </div>
              <span v-if="data.child.length > 0">
                <i class="el-icon-arrow-right"></i>
              </span> -->
            </div>
          </el-tree>
        </div>
      </div>
      <div slot="footer">
        <div class="submit">
          <el-button class="cancelBtn" @click="cancel"> 取消 </el-button>
          <el-button class="submitBtn" @click="query"> 确认 </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/apis/reservation";
// import moment from "moment";
import { uncompress } from "@/utils/tools";
export default {
  name: "home",
  props: ["visible", "userNames"],
  data() {
    return {
      treeListNode: [],
      filterText: "",
      infoList: {
        id: "",
        deptName: ""
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      list: [],
      nodeList: [],
      type: "",
      dialogVisible: false,
      selectList: [],
      user: [],
      treeList: [],
      loading: false
    };
  },
  created() {},
  mounted() {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    visible: {
      handler: function (newValue) {
        this.dialogVisible = newValue;
        if (newValue) {
          this.selectList = [];
          // this.treeListNode = this.treeList
          setTimeout(() => {
            this.getList();
          }, 10);
        }
        // 当 someObject 内部属性变化时会触发
      },
      deep: true // 开启深度监听
    }
    // visible(v) {
    //   this.dialogVisible = v;
    //   this.selectList = [];
    //   this.$nextTick(() => {
    //     this.$refs.tree.setCheckedKeys([]);
    //     console.log('111111111111');
    //   });
    //   if (v) {
    //     this.getList();
    //     const users = this.userNames;
    //     if (users.length > 0) {
    //       this.selectList = this.userNames;
    //       console.log(this.selectList, "this.selectList");
    //       this.user = users.length > 0 && users.map((i) => i.username);
    //       setTimeout(() => {
    //         const tree = this.$refs.tree;
    //         if (tree) {
    //           tree.setCheckedKeys(this.selectList);
    //           console.log('222222222222');
    //         }
    //       });
    //     }
    //   }
    // },
  },
  methods: {
    // 关闭弹窗
    beforeClose(done) {
      // this.selectList = [];
      this.treeList = [];
      this.$emit("update:visible", false);
      done();
    },
    //返回
    cancel() {
      this.treeList = [];
      this.filterText = "";
      this.$emit("update:visible", false);
    },
    //获取数据
    getList() {
      api.userDirectory().then(data => {
        const inflatedData = uncompress(data.data);
        this.treeList = inflatedData;
        const users = this.userNames;
        console.log(users, "users----");
        if (users.length > 0) {
          this.selectList = this.userNames;
          console.log(this.selectList, "this.selectList");
          this.user = users.length > 0 && users.map(i => i.username);
        } else {
          this.user = [];
        }
      });
    },
    //获取选中节点
    checkTree() {
      //   let str = [];
      let nodes1 = this.$refs.tree.getCheckedNodes(true);

      this.selectList = nodes1;
      this.user = nodes1.map(item => item.username);
      //   let nodes2 = this.$refs.tree.getCheckedNodes(true);
      console.log(nodes1, "nodes11");
      //   console.log(nodes2,'nodes22');
      //   nodes1.forEach((item) => {
      //     str.push({ id: item.id });
      //   });
      //   console.log(nodes, "nodes");
      //   localStorage.setItem("node", JSON.stringify(str));
    },
    //过滤树节点
    filterNode(value, data) {
      if (!value) return true;
      return data.nickname.indexOf(value) !== -1;
    },
    //关闭标签
    tagClose(tag) {
      if (!tag || !tag.username) {
        console.error("Invalid tag:", tag);
        return;
      }
      const index = this.selectList.findIndex(i => i.username === tag.username);
      this.selectList.splice(index, 1);
      this.$nextTick(() => {
        const keys = this.selectList.map(i => i.username);
        this.user = keys;
        const tree = this.$refs.tree;
        tree.setCheckedKeys(this.selectList);
      });
    },
    //确认选择
    query() {
      console.log(this.selectList, "selectList");
      // const tree = this.$refs.tree;
      // tree.setCheckedKeys([]);
      this.$emit("changeQuery", this.selectList);
      this.$emit("update:visible", false);
      this.treeList = [];
      this.filterText = "";
      // setTimeout(() => {
      //   this.selectList = [];
      // }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.tree {
  width: 100%;
  //   background: #ffffff;
  height: 88vh;
  overflow: auto;
  .input {
    margin: 20px 0;
    ::v-deep .el-input__inner {
      width: 100%;
      height: 70px;
      //   margin-left: 5%;
      padding-left: 70px;
      background: rgba(235, 237, 242, 1);
      border: none;
    }
    ::v-deep .el-input__icon {
      margin-left: 10px;
      font-size: 34px;
      margin-top: 3px;
    }
  }
  .treeList {
    height: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0px;
      height: 1px;
      background-color: rgba(240, 240, 240, 1);
    }
  }
  ::v-deep .el-checkbox {
    padding-left: 20px;
  }
  ::v-deep .el-tree-node__content > .el-tree-node__expand-icon {
    display: none;
  }
  ::v-deep .el-tree-node__content {
    display: flex;
    height: 70px !important;
    font-size: 22px;
    padding: 0 20px;
    border-bottom: 1px solid #f6f6f6;
  }
  .custom-tree-node {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    span {
      display: flex;
      align-items: center;
    }
    div {
      margin-left: 15px;
      display: flex;
      align-items: center;
      span {
        font-size: 32px;
        margin-left: 20px;
      }
    }
  }
  .el-icon-arrow-right {
    font-size: 32px;
    color: #ccc;
  }
}
// .submit {
//   // position: absolute;
//   // bottom: -20px;
//   // z-index: 99;
//   width: 20%;
//   margin-left: 40%;
//   margin-top: 20px;

//   .button {
//     width: 100%;
//     background: rgba(50, 106, 251, 1);
//     color: #fff;
//     height: 60px;
//     font-size: 30px;
//     padding-top: 15px;
//     border-radius: 100px;
//     // margin-left: 12.5%;
//   }
// }
.tag {
  // border: 1px solid #ccc;
  height: 18vh;
  border-radius: 10px;
  flex: 1;
  margin-top: 30px;
  padding-left: 30px;
  overflow: auto;
  .choose {
    margin-bottom: 20px;
  }
}
::v-deep {
  .el-dialog {
    margin: 0 !important;
    height: 100vh !important;
  }
  .el-dialog__body {
    padding: 0px 20px 20px;
    height: auto !important;
    // overflow: auto;
    // display: flex;
    // align-items: center;
    justify-content: center;
    &::-webkit-scrollbar {
      width: 0px;
      height: 1px;
      background-color: rgba(240, 240, 240, 1);
    }
  }
  .el-dialog__header {
    height: 0 !important;
    padding: 0 !important;
  }
  .el-tree-node {
    .is-leaf + .el-checkbox .el-checkbox__inner {
      display: inline-block;
    }
    .el-checkbox__input > .el-checkbox__inner {
      display: none;
    }
  }
  .el-tag {
    padding: 10px;
    margin-right: 10px;
    height: 60px !important;
    margin-bottom: 10px;
  }
}

.submit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.cancelBtn {
  color: #1fbe8a;
  border: 1px solid #1fbe8a;
  background: none;
  width: 200px !important;
  height: 65px !important;
  border-radius: 100px;
  margin-right: 20px;
}
.submitBtn {
  color: #fff;
  background: #1fbe8a;
  border: 1px solid #1fbe8a;
  width: 200px !important;
  height: 65px !important;
  border-radius: 100px;
}
</style>
